import { useState, useEffect } from 'react';

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: 'https://public.readdy.ai/ai/img_res/08fdb8e9c3ea05841637c8068f8a8711.jpg',
      alt: 'Luxury Home Exterior'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=opulent%20luxury%20living%20room%20interior%20with%20double-height%20ceilings%2C%20designer%20furniture%2C%20marble%20fireplace%2C%20crystal%20chandelier%2C%20floor-to-ceiling%20windows%20with%20city%20views%2C%20rich%20textures%20and%20premium%20materials%2C%20professional%20interior%20photography%20with%20warm%20ambient%20lighting%20and%20sophisticated%20color%20palette&width=1920&height=1080&seq=hero-luxury-living-002&orientation=landscape',
      alt: 'Luxury Living Room'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=high-end%20gourmet%20kitchen%20with%20custom%20Italian%20cabinetry%2C%20marble%20waterfall%20island%2C%20professional-grade%20appliances%2C%20wine%20storage%2C%20pendant%20lighting%2C%20and%20sleek%20modern%20design%2C%20professional%20interior%20photography%20showcasing%20premium%20finishes%20and%20elegant%20details%20with%20warm%20sophisticated%20lighting&width=1920&height=1080&seq=hero-luxury-kitchen-003&orientation=landscape',
      alt: 'Luxury Kitchen'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={slide.image}
              alt={slide.alt}
              className="w-full h-full object-cover object-top"
            />
          </div>
        ))}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Crafting <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">Luxury</span> Living Spaces
        </h1>
        <p className="text-xl md:text-2xl text-gray-200 mb-10 max-w-3xl mx-auto">
          Where architectural excellence meets unparalleled craftsmanship. Building dreams into reality since day one.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={scrollToContact}
            className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-8 py-4 rounded-md text-base font-bold hover:from-yellow-600 hover:to-yellow-700 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap"
          >
            Start Your Project
          </button>
          <a
            href="tel:214-864-0689"
            className="border-2 border-white text-white px-8 py-4 rounded-md text-base font-bold hover:bg-white hover:text-black transition-all whitespace-nowrap"
          >
            214-864-0689
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
              index === currentSlide ? 'bg-yellow-500 w-8' : 'bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
